const ContractFilter = () => {
    return <div>Coucou</div>;
};

export default ContractFilter;
